const existThisUnitInList = ({ unit, selectedItemList }) => {
  const { itemHash } = unit;
  if (!itemHash) {
    throw Error(`wrong input => unit:"${JSON.stringify(unit)}"`);
  }

  for (let i = 0; i < selectedItemList.length; i++) {
    const oneUnit = selectedItemList[i];
    if (!oneUnit.itemHash) {
      throw Error(`wrong list => unit:"${JSON.stringify(oneUnit)}"`);
    }

    if (oneUnit.itemHash === itemHash) {
      return true;
    }
  }
  return false;
};

const getRemovedList = ({ unit, selectedItemList }) => {
  const { itemHash } = unit;
  if (!itemHash) {
    throw Error(`wrong input => unit:"${JSON.stringify(unit)}"`);
  }
  const returnArr = [];

  for (let i = 0; i < selectedItemList.length; i++) {
    const oneUnit = selectedItemList[i];

    if (!oneUnit.itemHash) {
      throw Error(`wrong list => unit:"${JSON.stringify(oneUnit)}"`);
    }

    if (oneUnit.itemHash !== itemHash) returnArr.push(oneUnit);
  }

  return returnArr;
};

export { existThisUnitInList, getRemovedList };
